<script setup lang="ts">
import { onMounted, provide } from "vue";
import MInput from ".";

const validationController = [] as { validation: Function }[];

onMounted(() => {
  validationController.forEach((x) => x.validation());
});

provide("validationController", validationController);
</script>
<template>
  <div class="flex flex-col gap-3 m-ma-md">
    <!-- TODO: move decimal feature to MInputNumber.-->
    <m-input label="Decimal places 1" model-value="0.00001" decimal-places="1" />
    <m-input label="Decimal places 2" model-value="0.00001" decimal-places="2" />
    <m-input label="Decimal places 3" model-value="0" decimal-places="3" />

    <m-input label="Decimal places 3 with negative number" model-value="1.0" decimal-places="3" />

    <m-input
      label="Decimal places 5 with negative number (pre populated) (valid)"
      model-value="-0.00001"
      decimal-places="5"
    />

    <m-input label="Decimal places 5 (valid)" model-value="0.00001" decimal-places="5" />

    <m-input
      label="Decimal places 5 with negative number (pre populated) (invalid)"
      model-value="-0.000001"
      decimal-places="5"
      instructions="Initial value has 6 decimal places"
    />

    <m-input
      label="Decimal places 5 (invalid)"
      model-value="0.000001"
      decimal-places="5"
      instructions="Initial value has 6 decimal places"
    />
  </div>
</template>
